import { Color3, Color4, Quaternion, Vector3 } from '@babylonjs/core/Maths';
import { KbColor } from '@kb3d/models/classes/primitives/kb-color';
import { KbQuaternion } from '@kb3d/models/classes/primitives/kb-quaternion';
import { KbVector } from '@kb3d/models/classes/primitives/kb-vector';

/** KbVector extension methods - we have them here instead of in the class so that the class isn't referencing babylon */
declare module '@kb3d/models/classes/primitives/kb-vector' {
    interface KbVector {
        toVec3(ref?: Vector3): Vector3;
    }
    namespace KbVector {
        let FromVec3: (vector: Vector3) => KbVector;
    }
}
Object.defineProperty(KbVector.prototype, 'toVec3', {
    enumerable: false,
    writable: true,
    value: function (ref?: Vector3) {
        // add ref option
        if (!ref) {
            ref = new Vector3();
        }
        return this ? ref.copyFromFloats(this.x, this.y, this.z) : ref.setAll(0);
    },
});
Object.defineProperty(KbVector, 'FromVec3', {
    enumerable: false,
    writable: true,
    value: function (vector: Vector3) {
        return new KbVector(vector.x, vector.y, vector.z);
    },
});

/** KbQuaternion extension methods */
declare module '@kb3d/models/classes/primitives/kb-quaternion' {
    interface KbQuaternion {
        toQuat(): Quaternion;
    }
    namespace KbQuaternion {
        let FromQuat: (quaternion: Quaternion) => KbQuaternion;
    }
}
Object.defineProperty(KbQuaternion.prototype, 'toQuat', {
    enumerable: false,
    writable: true,
    value: function () {
        return this ? new Quaternion(this.x, this.y, this.z, this.w) : new Quaternion(0, 0, 0, 1);
    },
});
Object.defineProperty(KbQuaternion, 'FromQuat', {
    enumerable: false,
    writable: true,
    value: function (q: Quaternion) {
        return new KbQuaternion(q.x, q.y, q.z, q.w);
    },
});

/** KbColor extension methods */
declare module '@kb3d/models/classes/primitives/kb-color' {
    interface KbColor {
        toColor3(): Color3;
        toColor4(): Color4;
    }
}
Object.defineProperty(KbColor.prototype, 'toColor3', {
    enumerable: false,
    writable: true,
    value: function () {
        return this ? new Color3(this.r, this.g, this.b) : Color3.Black();
    },
});
Object.defineProperty(KbColor.prototype, 'toColor4', {
    enumerable: false,
    writable: true,
    value: function () {
        return this ? new Color4(this.r, this.g, this.b, this.a) : new Color4(0, 0, 0, 0);
    },
});
